let userStates ={
    'estado_usuario':[
        {
            name:'Activo',
            value:'ACTIVO'
        },
        {
            name:'Baja',
            value:'BAJA'
        },
        {
            name:'Bloqueado',
            value:'BLOQUEADO'
        },
        {
            name:'Inactivo',
            value:'INACTIVO'
        },
        {
            name:'Incompleto',
            value:'INCOMPLETO'
        }

    ],
    'estado_monotributo':[
        {
            name:'Activo',
            value:'ACTIVO'
        },
        {
            name:'Baja Oficio',
            value:'ERROR_BAJA_OFICIO'
        },
        {
            name:'Cancelado',
            value:'CANCELADO'
        },
        {
            name:'Cuit inactivo',
            value:'ERROR_CUIT_INACTIVO'
        },
        {
            name:'DDJJ s/ presentar',
            value:'ERROR_DDJJ_SIN_PRESENTAR'
        },
        {
            name:'DNI Vencido',
            value:'ERROR_DNI_VENCIDO'
        },
        {
            name:'Error clave fiscal',
            value:'ERROR_CLAVE_FISCAL_NIVEL_1'
        },
        {
            name:'Excluido (signup)',
            value:'EXCLUIDO'
        },
        {
            name:'Excluido (AFIP)',
            value:'ERROR_EXCLUIDO'
        },
        {
            name:'Hacer Alta',
            value:'HACER_ALTA'
        },
        {
            name:'Hacer Baja',
            value:'HACER_BAJA'
        },
        {
            name:'Inactivo',
            value:'INACTIVO'
        },
        {
            name:'Incompleto',
            value:'INCOMPLETO'
        },
        {
            name:'Pendiente revision',
            value:'PENDIENTE_REVISION'
        },
        {
            name:'Renaper',
            value:'ERROR_RENAPER'
        },
        {
            name:'Otros',
            value:'ERROR_OTROS'
        }
    ],
    'estado_clave_fiscal':[
        {
            name:'Activo',
            value:'ACTIVO'
        },
        {
            name:'Clave invalida',
            value:'ERROR_CLAVE_INVALIDA'
        },
        {
            name:'Creando',
            value:'CREANDO'
        },
        {
            name:'Inactivo',
            value:'INACTIVO'
        },
        {
            name:'Pendiente Revision',
            value:'PENDIENTE_REVISION'
        }

    ],
    'estado_pago':[
        {
            name:'Activo',
            value:'ACTIVO'
        },
        {
            name:'Activo Prueba',
            value:'ACTIVO_PRUEBA'
        },
        {
            name:'Inactivo',
            value:'INACTIVO'
        },
        {
            name:'Pago en proceso',
            value:'PAGO_EN_PROCESO'
        },
        {
            name:'Por vencer',
            value:'POR_VENCER'
        },
        {
            name:'Vencido',
            value:'VENCIDO'
        }
    ]

}
export default userStates